import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import * as fromRootStore from "../../../reducers";
import { Combo2Service, EstiWorkOrderService } from "../../../services/index";
import { PrintWorkOrder } from "../workorder/printWO";
declare var google;

@Component({
  selector: "estimateWoReport",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./estimateWoReports.html"
})
export class estimateWoReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  verifierId: number;
  verifier: string;
  cancelWo_no: string;
  seasonList = [];
  gridOptions: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;

  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  filter = {
    shirt_design: "",
    wo_no: "",
    order_from_date: "",
    order_to_date: "",
    wo_from_date: "",
    wo_to_date: "",
    fab_design: "",
    status: "ALL"
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "ref_no",
    orderDir: "desc"
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];
  statusList = [
    {
      value: "ALL"
    },
    {
      value: "PROCESS"
    },
    {
      value: "CANCELLED"
    },
    {
      value: "CONVERTED"
    }
  ];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("verifyTemplate") verifyTemplate: TemplateRef<any>;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  // filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  wono: "";
  wo_id: "";

  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    private woservice: EstiWorkOrderService,
    private modalService: BsModalService,
    public toasterService: ToasterService,
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center"
      },
      {
        name: "Ref No",
        prop: "ref_no",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80
      },
      {
        name: "Date",
        prop: "fdate",
        headerClass: "text-center",
        minWidth: 100,
        maxWidth: 100,
        width: 100
      },
      {
        name: "WO No",
        prop: "wo_no",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80
      },
      {
        name: "Fab Design",
        prop: "fab_design",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120
      },
      {
        name: "Shirt DNo",
        prop: "shirt_design_no",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120
      },
      {
        name: "Status",
        prop: "status",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120
      },
      {
        name: "Verified by",
        prop: "verifiedby",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120
      },
      {
        name: "Action",
        prop: "sno",
        minWidth: 60,
        maxWidth: 100,
        width: 100,
        sortable: false,
        cellTemplate: this.editDeleteTemplate
      }
    ];
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getEstimateOrderReportList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  verify(row) {
    this.wono = row.wono;
    this.wo_id = row.wo_id;
  }

  clearFilter(): void {
    this.filter.shirt_design = "";
    this.filter.wo_no = "";
    this.filter.order_from_date = "";
    this.filter.order_to_date = "";
    this.filter.fab_design = "";
    this.filter.status = "ALL";
    this.applyFilter();
  }

  applyFilter(): void {
    this.getEstimateOrderReportList();
  }

  closeModal() {
    var verifiedby1 = document.getElementById("verifiedby") as HTMLInputElement;
    this.wono = "";
    this.wo_id = "";
    verifiedby1.value = "";
    this.getEstimateOrderReportList();
  }

  saveModal() {
    var verifytemp = document.getElementById("verifiedby") as HTMLInputElement;
    var verifiedby = verifytemp.value;
    let params = {
      ew_wo_id: this.wo_id,
      ew_wono: this.wono,
      ew_verifiedby: verifiedby
    };
    let that = this;
    this.woservice.saveEstimateVerifyWO(params).then(function(res: any) {
      that.getEstimateOrderReportList();
    });
    this.wo_id = "";
    this.wono = "";
    verifytemp.value = "";
  }

  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function(res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }

  addEditPO(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getEstimateOrderReportList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "View") {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "VIEW ESTIMATE WORK ORDER",
          title: "VIEW ESTIMATE WORK ORDER",
          tabParent: "PURCHASE",
          mode: mode,
          data: row,
          name: "VIEW ESTIMATE WORK ORDER"
        }
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }

  bsModalRef: BsModalRef;
  print(row) {
    let params = {
      printType: "invoice",
      party_id: row.party_id,
      dcid: row.dcid
    };

    this.bsModalRef = this.modalService.show(PrintWorkOrder, {
      keyboard: false,
      ignoreBackdropClick: true,
      class: "modal-lg compWidth-96"
    });
    this.bsModalRef.content.printdt = Object.assign({}, row);
    // this.bsModalRef.content.printcontent = this.printData;
  }

  getEstimateOrderReportList(): void {
    if (this.filter.wo_from_date !== "") {
      this.filter.wo_from_date = this.datePipe.transform(
        this.filter.wo_from_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filter.wo_to_date !== "") {
      this.filter.wo_to_date = this.datePipe.transform(
        this.filter.wo_to_date,
        "yyyy-MM-dd"
      );
    }
    let params = {
      start: `${this.page.offset * (this.page.limit)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      shirt_design: this.filter.shirt_design,
      wo_no: this.filter.wo_no,
      wo_from_date: this.filter.wo_from_date,
      wo_to_date: this.filter.wo_to_date,
      fab_design: this.filter.fab_design,
      status: this.filter.status,
      verifiedby: "REPORT"
      //order_from_date:this.filter.order_from_date
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.woservice
      .getEstimateOrderReportList(params)
      .then(function(res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;
      });
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/woreports/estimateWoReports.ts